import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ProfileImage from '@fiverr-private/profile_image/src/ProfileImage';
import { MP_CLICKED_SELLER_NAME_ANCHOR } from '../../../utils/mixPanelEvents';
import { ABOUT_SELLER } from '../../../utils/pageSections';

import './style.scss';

const IMAGE_SIZE = 32;

const getSellerProfileImage = ({ id, achievement, hasProfilePhoto, username, profilePhoto, isPro }) => ({
    user_id: id,
    is_seller: true,
    achievement,
    has_profile_photo: hasProfilePhoto,
    username,
    profile_photo: profilePhoto,
    is_pro: isPro
});

const getStudioProfileImage = ({ id, name, profilePhoto }) => ({
    user_id: id,
    is_seller: true,
    profile_photo: profilePhoto,
    has_profile_photo: !!profilePhoto,
    username: name
});

class OverviewProfileImage extends PureComponent {

    constructor(props) {
        super(props);

        this.onUsernameClick = this.onUsernameClick.bind(this);
    }

    onUsernameClick(e) {
        const { scrollToSection } = this.props;
        const { biEvents } = this.context;

        e.preventDefault();

        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_SELLER_NAME_ANCHOR });
        scrollToSection({ sectionKey: ABOUT_SELLER });
    }

    getProfileImage() {
        const { general } = this.context;
        const { studioInfo, seller } = this.props;
        const { isStudio } = general;

        return isStudio ? getStudioProfileImage(studioInfo) : getSellerProfileImage(seller);
    }

    render() {
        const { useStickyLayout } = this.props;
        const { general } = this.context;
        const { isStudio } = general;

        const profileImage = this.getProfileImage();
        let onUsernameClick = null,
            noLink = true;

        if (useStickyLayout) {
            onUsernameClick = this.onUsernameClick;
            noLink = false;
        }

        return (
            <ProfileImage user={profileImage}
                allowEditing={false}
                profileImageSize={IMAGE_SIZE}
                showUserNameLevel={true}
                onUsernameClick={onUsernameClick}
                hintPos="hint--top"
                noLink={noLink}
                isStudio={isStudio}/>
        );
    }
}

OverviewProfileImage.propTypes = {
    seller: PropTypes.shape({
        id: PropTypes.number.isRequired,
        username: PropTypes.string,
        achievement: PropTypes.number,
        isPro: PropTypes.bool,
        hasProfilePhoto: PropTypes.bool,
        profilePhoto: PropTypes.string
    }),
    studioInfo: PropTypes.shape({
        id: PropTypes.number,
        username: PropTypes.string,
        slug: PropTypes.string,
        tagline: PropTypes.string,
        description: PropTypes.string,
        profilePhoto: PropTypes.string,
        reviewsCount: PropTypes.number,
        rating: PropTypes.number
    }),
    scrollToSection: PropTypes.func,
    useStickyLayout: PropTypes.bool
};

OverviewProfileImage.contextTypes = {
    biEvents: PropTypes.object,
    general: PropTypes.object
};

export default OverviewProfileImage;

